"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var selectSurfaceActionsOption_1 = require("../actions/selectSurfaceActionsOption");
var Button_1 = require("office-ui-fabric-react/lib/Button");
var owa_options_controls_1 = require("owa-options-controls");
var ContextualMenu_1 = require("office-ui-fabric-react/lib/ContextualMenu");
var Icon_1 = require("office-ui-fabric-react/lib/Icon");
var Image_1 = require("office-ui-fabric-react/lib/Image");
var Label_1 = require("office-ui-fabric-react/lib/Label");
var OverflowSet_1 = require("office-ui-fabric-react/lib/OverflowSet");
var owa_surface_actions_1 = require("owa-surface-actions");
var React = require("react");
var DIVIDER_MENU_ITEM_NAME = '-';
var MAX_PINNED_ITEMS = 8;
var styles = require('./SurfaceActions.scss');
var classNames = require('classnames/bind').bind(styles);
var SurfaceActionsShared = /** @class */ (function (_super) {
    tslib_1.__extends(SurfaceActionsShared, _super);
    function SurfaceActionsShared() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onRenderActionCheckboxLabel = function (props, key) {
            var label = _this.props.getDisplayNameFromAction(key);
            var _a = _this.props.getIconNameFromAction(key), icon = _a[0], isImage = _a[1];
            var className = isImage ? styles.imageWrapper : '';
            return (React.createElement("div", { className: className },
                isImage ? (React.createElement(Image_1.Image, { className: styles.actionImage, shouldFadeIn: false, src: icon })) : (React.createElement(Icon_1.Icon, { iconName: icon, className: styles.actionIcon })),
                React.createElement(Label_1.Label, { className: styles.actionLabel },
                    " ",
                    label,
                    " ")));
        };
        _this.onRenderAddinCheckboxLabel = function (props, iconProps, name) {
            return (React.createElement("div", null,
                React.createElement(Icon_1.Icon, { iconType: iconProps.iconType, className: styles.addinImage, imageProps: iconProps.imageProps }),
                React.createElement(Label_1.Label, { className: styles.actionLabel },
                    " ",
                    name,
                    " ")));
        };
        _this.onRenderPreviewItem = function (item) {
            var className = classNames(styles.previewButton, { isAddin: item.isAddin });
            return (React.createElement(Button_1.CommandBarButton, { onClick: null, iconProps: item.iconProps, styles: { root: className } }));
        };
        _this.onRenderPreviewOverflow = function (overflowItems) {
            overflowItems.forEach(function (item) {
                if (!item.isAddin) {
                    item.iconProps = null; // Hide static action icons in the overflow
                }
            });
            return (React.createElement(Button_1.CommandBarButton, { menuIconProps: { iconName: 'ChevronDown' }, menuProps: { items: overflowItems }, styles: { root: styles.previewButton } }));
        };
        return _this;
    }
    SurfaceActionsShared.prototype.render = function () {
        var _a = this.props, previewImageUri = _a.previewImageUri, previewClassName = _a.previewClassName;
        var actionCheckboxes = [];
        var addinCheckboxes = [];
        var previewPinnedItems = [];
        var previewOverflowItems = [];
        this.prepareActionsContent(actionCheckboxes, previewPinnedItems, previewOverflowItems);
        this.prepareAddinsContent(addinCheckboxes, previewPinnedItems, previewOverflowItems);
        return (React.createElement("div", { className: styles.sharedWrapper },
            React.createElement("div", { className: styles.sharedListSection },
                actionCheckboxes,
                addinCheckboxes),
            React.createElement("div", { className: styles.sharedPreviewSection },
                React.createElement(Image_1.Image, { src: previewImageUri, className: 'flipForRtl' }),
                React.createElement(OverflowSet_1.OverflowSet, { className: previewClassName, items: previewPinnedItems, overflowItems: previewOverflowItems, onRenderItem: this.onRenderPreviewItem, onRenderOverflowButton: this.onRenderPreviewOverflow }))));
    };
    SurfaceActionsShared.prototype.prepareActionsContent = function (actionCheckboxes, previewPinnedItems, previewOverflowItems) {
        var _this = this;
        var _a = this.props, actions = _a.actions, selectedActions = _a.selectedActions, actionsOptionName = _a.actionsOptionName;
        actions.forEach(function (action) {
            var isPinned = selectedActions.indexOf(action) >= 0;
            if (action != DIVIDER_MENU_ITEM_NAME) {
                // If the action isn't a divider, create a OptionsCheckbox for it.
                actionCheckboxes.push(React.createElement(owa_options_controls_1.OptionsCheckbox, { checked: isPinned, onChange: function (event, checked) {
                        selectSurfaceActionsOption_1.default(actionsOptionName, selectedActions, action, checked);
                    }, key: action, onRenderLabel: function (props) {
                        return _this.onRenderActionCheckboxLabel(props, action);
                    }, styles: { label: styles.checkBoxLabel } }));
                // If the action is pinned, push a preview of it to the proper collection
                if (isPinned) {
                    var _a = _this.props.getIconNameFromAction(action), iconName = _a[0], isImage = _a[1];
                    var previewAction = {
                        key: action,
                        isAddin: false,
                        iconProps: {
                            iconName: iconName,
                            iconType: isImage ? Icon_1.IconType.Image : Icon_1.IconType.default,
                            imageProps: isImage ? { shouldFadeIn: false, src: iconName } : null,
                        },
                        name: _this.props.getDisplayNameFromAction(action),
                    };
                    _this.addPreviewItem(previewAction, previewPinnedItems, previewOverflowItems);
                }
            }
        });
    };
    SurfaceActionsShared.prototype.prepareAddinsContent = function (addinCheckboxes, previewPinnedItems, previewOverflowItems) {
        var _this = this;
        var _a = this.props, addins = _a.addins, selectedAddins = _a.selectedAddins, addinsOptionName = _a.addinsOptionName;
        addins.forEach(function (addin) {
            var isPinned = selectedAddins.indexOf(addin.key) >= 0;
            if (addin.itemType == ContextualMenu_1.ContextualMenuItemType.Normal) {
                addinCheckboxes.push(React.createElement(owa_options_controls_1.OptionsCheckbox, { checked: isPinned, onChange: function (event, checked) {
                        selectSurfaceActionsOption_1.default(addinsOptionName, selectedAddins, addin.key, checked);
                    }, key: addin.key, onRenderLabel: function (props) {
                        return _this.onRenderAddinCheckboxLabel(props, addin.iconProps, addin.name);
                    }, styles: { label: styles.checkBoxLabel } }));
                // If the addin is pinned, push a preview of it to the proper collection
                if (isPinned) {
                    var previewAddin = {
                        key: addin.key,
                        isAddin: true,
                        iconProps: addin.iconProps,
                        name: addin.name,
                    };
                    _this.addPreviewItem(previewAddin, previewPinnedItems, previewOverflowItems);
                }
            }
        });
    };
    SurfaceActionsShared.prototype.addPreviewItem = function (item, pinnedItems, overflowItems) {
        var isLeftToRight = this.props.isLeftToRight;
        // If we have fewer than the max pinned items and no overflow items, push to the pinned collection.
        if (pinnedItems.length < MAX_PINNED_ITEMS && overflowItems.length == 0) {
            if (isLeftToRight || owa_surface_actions_1.shouldAddActionToEnd(item.key)) {
                pinnedItems.push(item);
            }
            else {
                pinnedItems.unshift(item);
            }
        }
        else if (pinnedItems.length == MAX_PINNED_ITEMS) {
            // Otherwise, if we have exactly the max amount of pinned items, remove one and add it to the overflow along with the new item.
            overflowItems.push(isLeftToRight ? pinnedItems.pop() : pinnedItems.shift());
            overflowItems.push(item);
        }
        else {
            // Otherwise push to the overflow.
            overflowItems.push(item);
        }
    };
    return SurfaceActionsShared;
}(React.Component));
exports.default = SurfaceActionsShared;
//# sourceMappingURL=SurfaceActionsShared.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-surface-actions-option/lib/components/SurfaceActionsShared.js
// module id = 5238
// module chunks = 2